import type { FC } from "react";
import * as styles from "./styles.module.scss";

const AllSomethingHeader: FC<{ text: string; className: string }> = ({ text, className }) => {
    return <h1 className={[styles.title, className].join(" ")}>{text}</h1>;
};

export default AllSomethingHeader;
